import * as React from 'react';
import { ELayoutTypes, ERoomsCount } from '../../types/newbuilding/layouts';
import { RadioButton } from './RadioButton';

import * as styles from './styles.css';

interface IOption {
  value: ERoomsCount | ELayoutTypes;
  label: string;
  disabled?: boolean;
}

export const RadioButtonsMultiple = ({
  options,
  name,
  onClick,
  initialValue,
}: {
  options: IOption[];
  name: string;
  initialValue?: ERoomsCount | ELayoutTypes;
  onClick(value: ERoomsCount | ELayoutTypes | undefined): void;
}) => {
  return (
    <div className={styles['buttons']}>
      {options.map(({ value, label, disabled = false }) => (
        <RadioButton
          key={value}
          onChange={() => {
            onClick(value);
          }}
          checked={value === initialValue}
          disabled={disabled}
          label={label}
          name={name}
          value={value}
        />
      ))}
    </div>
  );
};
